var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('NavigationDrawer',[_c('v-list',[_c('SideNavLink',{attrs:{"to":{ name: 'settings-disabled-apps' },"icon":"mdi-apps-box"}},[_vm._v(" Disabled Apps ")])],1)],1),(_vm.currentView === 'settings-disabled-apps')?_c('SettingsDisabledApps'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }